// „Liste einfügen“ (Anfragen & Bestellungen): Jasmin tippt/kopiert eine Liste
//   15 Spulen D0,8 SG3 von Novofil
//   20 Kg 1.4462 D2,4 WIG – Hersteller egal, bitte das günstigste nehmen
// → je Zeile Stück / Was / Lieferant. Der Lieferant („von …“) ist nur ein Wunsch und
// steht im Kommentar („Wunschlieferant: X“) — „Angefragt bei“ wird erst beim Anfragen gesetzt.

export type ListenZeile = { stueck: string; was: string; lieferant: string };

const EINHEIT = '(?:Spulen?|Rollen?|Kg|Stk\\.?|St\\.|Stück|Fass|Fässer|Dosen?|Liter|Ltr\\.?|Meter|Pack|Pakete?|Paar|Kartons?|Säcke|Sack|Flaschen?|Bunde?|Sätze|Satz|Kisten?|Eimer|Tafeln?|Platten?|Stangen?|Kanister|Gebinde|Beutel|m|l)';
// „15 Spulen …“, „10x EW Palette …“, „10 × Rahmen …“
const RE_MENGE = new RegExp(`^(\\d+(?:[.,]\\d+)?)\\s*(?:[x×](?=\\s))?\\s*(${EINHEIT})?(?=\\s|$)\\s*(.*)$`, 'i');
const RE_VON = /\s+von\s+([A-Za-zÄÖÜäöüß][^\d–—,;]{1,40}?)\s*$/i;

export function parseListeZeile(roh: string): ListenZeile | null {
  const zeile = roh.replace(/^\s*[-•*·]\s+/, '').trim();
  if (!zeile) return null;
  const m = RE_MENGE.exec(zeile);
  let stueck = '';
  let rest = zeile;
  if (m) {
    stueck = [m[1], m[2]].filter(Boolean).join(' ');
    rest = (m[3] ?? '').trim();
  }
  let lieferant = '';
  const v = RE_VON.exec(rest);
  if (v) { lieferant = (v[1] ?? '').trim(); rest = rest.slice(0, v.index).trim(); }
  return { stueck, was: rest, lieferant };
}

export function parseListe(text: string): ListenZeile[] {
  return text.split(/\r?\n/).map(parseListeZeile).filter((z): z is ListenZeile => !!z && (z.was !== '' || z.stueck !== ''));
}

const WUNSCH = /Wunschlieferant:\s*([^;\n]+)/i;
export const wunschKommentar = (lieferant: string) => (lieferant.trim() ? `Wunschlieferant: ${lieferant.trim()}` : null);
export const wunschVon = (r: { kommentar?: string | null }): string => (WUNSCH.exec(r.kommentar ?? '')?.[1] ?? '').trim();
// „Dratec“ passt zu „Dratec GmbH“ und umgekehrt
export const gleicherLieferant = (a: string, b: string) => {
  const x = a.trim().toLowerCase(), y = b.trim().toLowerCase();
  return !!x && !!y && (x === y || x.includes(y) || y.includes(x));
};

// Mehrzeilig einfügen (Neuer Eintrag): „10x EW Palette 800x600 à 6,40€/Stück“
//   → Stück „10“, Was „EW Palette 800x600“, Preis „6,40 €“, Einheit „Stück“
const RE_PREIS = /\s*[-–,;]?\s*(?:à|á|@)\s*(\d+(?:[.,]\d+)?)\s*(?:€|EUR|Euro)?(?:\s*(?:\/|pro\s+)\s*([A-Za-zÄÖÜäöüß.]+))?\s*$/i;
export type MehrzeilenPosition = { stueck: string; was: string; preis: string; einheit: string };

export function parseMehrzeilig(text: string): MehrzeilenPosition[] {
  const out: MehrzeilenPosition[] = [];
  for (const roh of text.split(/\r?\n/)) {
    const z = parseListeZeile(roh);
    if (!z || (!z.was && !z.stueck)) continue;
    let was = z.was; let preis = ''; let einheit = '';
    const m = RE_PREIS.exec(was);
    if (m) { preis = `${m[1]} €`; einheit = m[2] ?? ''; was = was.slice(0, m.index).trim(); }
    out.push({ stueck: z.stueck, was, preis, einheit });
  }
  return out;
}
